export const mutations = {
  STORE_STATIONS(state, stations) {
    state.stations = stations;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/stations/mutations.js